enum MD_STANDARD {
	NONE    = 'NONE',
	COMMENT = 'COMMENT',
	SYSTEM  = 'SYSTEM',
}

export default MD_STANDARD;
